import { Box, Typography } from "@mui/material";

const baseSx = {
  textDecoration: "none",
  color: "white",
  bgcolor: "header.main",
  border: "1px solid rgba(255, 255, 255, 0.5)",
  borderRadius: 0.5,
  py: 2.5,
  textAlign: "center",
  transition: "background-color 0.2s ease, border-color 0.2s ease",
  "&:hover": {
    bgcolor: "#1a4d85",
    borderColor: "rgba(255, 255, 255, 0.65)",
  },
};

export default function StoreCalloutBanner({
  href,
  headline,
  subline,
  compact = false,
  sx,
}) {
  return (
    <Box
      component="a"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        ...baseSx,
        px: { xs: 2, sm: compact ? 2 : 4 },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: { xs: "auto", md: "100%" },
        ...sx,
      }}
    >
      <Typography
        variant={compact ? "subtitle1" : "h6"}
        component="p"
        sx={{ fontWeight: 600, mb: 0.5 }}
      >
        {headline}
      </Typography>
      <Typography variant="body2" sx={{ opacity: 0.9 }}>
        {subline}
      </Typography>
    </Box>
  );
}
